import * as datastore from '@/datastore'

export interface ShoppingListItem extends datastore.Reference {
	createdAt?: number
	createdBy?: string
	name: string
	notes: string
	pantryItemId?: string
	preferredBrands: string[]
	quantity: number
}

export const defaultShoppingListItem: Readonly<ShoppingListItem> = {
	$id: '',
	name: '',
	notes: '',
	preferredBrands: [],
	quantity: 1,
}
